import {FC} from "react";
import {StatusUiProps} from "./StatusUiProps";
import {StatusIndicator} from "./StatusIndicator";
import {IconComponent} from "./IconComponent";

/**
 * A simple UI that is rendered when a script
 * fails to inject its associated source.
 *
 * @param scriptId
 * @param className
 * @constructor
 */
export const DefaultFailureIndicator: FC<StatusUiProps> = ({
  scriptId,
  className
}) => {
  return (
    <StatusIndicator
      scriptId={scriptId}
      status={"failure"}
      className={className}>
      <p>Failure loading {scriptId}</p>
      <IconComponent color={"rgba(221, 43, 43, 0.1)"} />
    </StatusIndicator>
  );
};
